import React, {useState} from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import HeightIcon from "@mui/icons-material/Height";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import {Box, IconButton, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {ItemContainerBuilderCol} from "./ItemContainerBuilderCol";
import RowHeigthDialog from "./RowHeigthDialog";
import {useItemContainerBuilder} from "./useItemContainerBuilder";

const MAX_VIEW_PER_ROW = 4;

const rowActionStyle = {
  // width: "48px"
};

export const ItemContainerBuilderRow = ({row, rowIdx}) => {
  const {t} = useTranslation();
  const {
    handleRowRemove,
    handleColAdd,
    handleRowHeight,
    getRowItemProps,
    getRowMoveCursorProps,
    getColContainerProps,
    getRowHeightValue
  } = useItemContainerBuilder();

  const [isRowHeightOpen, setIsRowHeightOpen] = useState(false);

  return (
    <Box
      style={{flexGrow: 1}}
      sx={{
        width: "100%"
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          width: "100%"
        }}
        {...getRowItemProps(rowIdx)}
      >
        {row.map((col, idx) => {
          return (
            <React.Fragment key={idx}>
              <div style={{display: "flex", width: "100%"}} {...getColContainerProps(rowIdx, idx)}>
                <ItemContainerBuilderCol rowIdx={rowIdx} colIdx={idx} col={col} />
              </div>
            </React.Fragment>
          );
        })}
        <Box
          style={{flexGrow: 1}}
          sx={{
            display: "flex",
            verticalAlign: "middle",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <Tooltip title={t("components.itemContainerBuilder.actions.addColumn")}>
            <span>
              <IconButton
                className="item-container-builder-row__add-column"
                sx={rowActionStyle}
                onClick={() => handleColAdd(rowIdx)}
                disabled={row.length === MAX_VIEW_PER_ROW}
              >
                <AddIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t("components.itemContainerBuilder.actions.removeRow")}>
            <IconButton
              className="item-container-builder-row__remove-row"
              sx={rowActionStyle}
              onClick={() => handleRowRemove(rowIdx)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip
            className="item-container-builder-row__move-row"
            title={t("components.itemContainerBuilder.actions.moveRow")}
          >
            <IconButton {...getRowMoveCursorProps(rowIdx)}>
              <OpenWithIcon />
            </IconButton>
          </Tooltip>
          <Tooltip
            className="item-container-builder-row__set-row-height"
            title={t("components.itemContainerBuilder.actions.setRowHeight")}
          >
            <IconButton onClick={() => setIsRowHeightOpen(true)}>
              <HeightIcon />
            </IconButton>
          </Tooltip>
          <RowHeigthDialog
            initialValue={getRowHeightValue(rowIdx)}
            open={isRowHeightOpen}
            onClose={() => setIsRowHeightOpen(false)}
            onSubmit={(height: number) => {
              handleRowHeight(rowIdx, height);
              setIsRowHeightOpen(false);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
